import React from "react";
import Helmet from "react-helmet";

export default () => (
  <div>
    <div className="container">
      <div className="row">
        <div className="col-xs">
          <Helmet>
            <style>
              {`/*body {
                font-size: 14px;
                font-family: sans-serif;
                line-height: 1.2;
                padding: 2rem;
              }
              .part ol ol.sections {
                font-size: 1.3rem;
                font-weight: bold;
              }
              li.section {
                font-size: 1.1rem;
                font-weight: bold;
              }
              ol.units {
                font-size: 1rem;
                font-weight: normal;
              }
              h1 {
                font-size: 2rem;
                font-weight: bold;
                margin: 0 0 3rem 0;
              }
              li.partTitle h2 {
                font-size: 1.3rem;
                font-weight: bold;
                margin: 0;
              }
              ol.sections li.sectionTitle h3 {
                font-size: 1.1rem;
                font-weight: bold;
                margin: 0;
              }
              */

              /*  The CSS below this comment is very important and must be added to the page that displays the document. 
                  Without these styles, the numbering, and display of numbers doesn't work.
                  Be careful with your own site styles, they may interfere with the display of your document.
                  You might need to add to the styles below to get the style you'd like.
              */
              .part ol {
                counter-reset: sectioncounter partcounter;
                margin: 0px;
                padding: 0px;
              }
              ol.sections {
                counter-reset: sectioncounter;
                margin: 0px;
                padding: 0px;
              }
              ol.sections li {
                list-style: none;
                margin-left: 2rem;
                position: relative;
              }
              ol.units {
                counter-reset: unitcounter;
                margin: 0 0 2rem 0;
              }
              ol.sections li.partTitle {
                list-style: none;
                counter-increment: none;
                counter-reset: numberedpart;
                margin-left: 0;
              }
              ol.sections li.sectionTitle {
                list-style: none;
                counter-increment: none;
                counter-reset: numberedsection;
                margin-left: 0;
              }
              ol.sections li.unnumberedunit {
                  margin-left: 0;
              }
              .sections li:before {
                position: absolute;
                left: -2rem;
              }
              .sections li.numberedpart:before {
                content: counter(partcounter, DECIMAL) ". ";
                counter-increment: partcounter;
              }
              .sections li.numberedsection:before {
                content: counter(sectioncounter, DECIMAL) ". ";
                counter-increment: sectioncounter;
              }
              .units li.numberedunit:before {
                content: counter(sectioncounter, DECIMAL) "." counter(unitcounter, DECIMAL) " ";
                counter-increment: unitcounter;
              }
              .unnumberedsection .units li.numberedunit:before {
                content: counter(unitcounter, DECIMAL) " ";
                counter-increment: unitcounter;
              }
              ol.sections li.definitionli {
                margin-left: 0;
              }
              li.unit ol,
              li.unit ol ol ol {
                counter-reset: loweralpha;
              }
              li.unit ol:not(.unnumbered) li:before,
              li.unit ol ol ol:not(.unnumbered) li:before {
                content: "(" counter(loweralpha, lower-alpha) ") ";
                counter-increment: loweralpha;
              }
              li.unit ol ol,
              li.unit ol ol ol ol {
                counter-reset: lowerroman;
              }
              li.unit ol ol:not(.unnumbered) li:before,
              li.unit ol ol ol ol:not(.unnumbered) li:before {
                content: "(" counter(lowerroman, lower-roman) ") ";
                counter-increment: lowerroman;
              }
              li.unit ol.unnumbered ol li:before,
              li.unit ol ol ol.unnumbered ol li:before {
                content: "(" counter(lowerroman, lower-alpha) ") ";
                counter-increment: lowerroman;
              }
              .part dfn {
                font-weight: bold;
              }

              /* overrides */
              .sections li.numberedsection:before {
                font-size: 1.4rem;
              }
              ol.sections li {
                margin-left: 3rem;
              }
              ol.sections li:before {
                left: -3rem;
              }
          `}
            </style>
          </Helmet>
          <h1>Terms and conditions of use</h1>
          <section className="part unnumberedpart">
            <ol className="sections">
              <li className="section numberedsection">
                <ol className="units">
                  <li className="sectionTitle">
                    <h3>Introduction</h3>
                  </li>
                  <li className="unit numberedunit">
                    These terms and conditions shall govern your use of our
                    website.
                  </li>
                  <li className="unit numberedunit">
                    By using our website, you accept these terms and conditions
                    in full; accordingly, if you disagree with these terms and
                    conditions or any part of these terms and conditions, you
                    must not use our website.
                  </li>
                  <li className="unit numberedunit">
                    If you register with our website, we will ask you to
                    expressly agree to these terms and conditions.
                  </li>
                  <li className="unit numberedunit">
                    You must be at least 18 years of age to use our website; by
                    using our website or agreeing to these terms and conditions,
                    you warrant and represent to us that you are at least 18
                    years of age.
                  </li>
                  <li className="unit numberedunit">
                    Our website uses cookies; by using our website or agreeing
                    to these terms and conditions, you consent to our use of
                    cookies in accordance with the terms of our privacy and
                    cookies policy.
                  </li>
                </ol>
              </li>
              <li className="section numberedsection">
                <ol className="units">
                  <li className="sectionTitle">
                    <h3>Copyright notice</h3>
                  </li>
                  <li className="unit numberedunit">
                    Copyright (c) 2020 Graphile Ltd.
                  </li>
                  <li className="unit numberedunit">
                    Subject to the express provisions of these terms and
                    conditions:
                    <ol className="listitem  ">
                      <li>
                        we, together with our licensors, own and control all the
                        copyright and other intellectual property rights in our
                        website and the material on our website; and
                      </li>
                      <li>
                        all the copyright and other intellectual property rights
                        in our website and the material on our website are
                        reserved.
                      </li>
                    </ol>
                  </li>
                </ol>
              </li>
              <li className="section numberedsection">
                <ol className="units">
                  <li className="sectionTitle">
                    <h3>Licence to use website</h3>
                  </li>
                  <li className="unit numberedunit">
                    You may:
                    <ol className="listitem  ">
                      <li>view pages from our website in a web browser;</li>
                      <li>
                        download pages from our website for caching in a web
                        browser;
                      </li>
                      <li>print pages from our website; and</li>
                      <li className="">
                        use our website services by means of a web browser,
                      </li>
                    </ol>
                    subject to the other provisions of these terms and
                    conditions.
                  </li>
                  <li className="unit numberedunit">
                    Except as expressly permitted by Section 3.1 or the other
                    provisions of these terms and conditions, you must not
                    download any material from our website or save any such
                    material to your computer.
                  </li>
                  <li className="unit numberedunit">
                    You may only use our website for your own personal and
                    business purposes, and you must not use our website for any
                    other purposes.
                  </li>
                  <li className="unit numberedunit">
                    Except as expressly permitted by these terms and conditions,
                    you must not edit or otherwise modify any material on our
                    website.
                  </li>
                  <li className="unit numberedunit">
                    Unless you own or control the relevant rights in the
                    material, you must not:
                    <ol className="listitem  ">
                      <li>
                        republish material from our website (including
                        republication on another website);
                      </li>
                      <li>
                        sell, rent or sub-license material from our website;
                      </li>
                      <li>show any material from our website in public;</li>
                      <li>
                        exploit material from our website for a commercial
                        purpose; or
                      </li>
                      <li>redistribute material from our website.</li>
                    </ol>
                  </li>
                  <li className="unit numberedunit">
                    We reserve the right to restrict access to areas of our
                    website, or indeed our whole website, at our discretion; you
                    must not circumvent or bypass, or attempt to circumvent or
                    bypass, any access restriction measures on our website.
                  </li>
                </ol>
              </li>
              <li className="section numberedsection">
                <ol className="units">
                  <li className="sectionTitle">
                    <h3>Acceptable use</h3>
                  </li>
                  <li className="unit numberedunit">
                    You must not:
                    <ol className="listitem  ">
                      <li>
                        use our website in any way or take any action that
                        causes, or may cause, damage to the website or
                        impairment of the performance, availability or
                        accessibility of the website;
                      </li>
                      <li>
                        use our website in any way that is unlawful, illegal,
                        fraudulent or harmful, or in connection with any
                        unlawful, illegal, fraudulent or harmful purpose or
                        activity;
                      </li>
                      <li>
                        use our website to copy, store, host, transmit, send,
                        use, publish or distribute any material which consists
                        of (or is linked to) any spyware, computer virus, Trojan
                        horse, worm, keystroke logger, rootkit or other
                        malicious computer software;
                      </li>
                      <li>
                        conduct any systematic or automated data collection
                        activities (including without limitation scraping, data
                        mining, data extraction and data harvesting) on or in
                        relation to our website without our express written
                        consent;
                      </li>
                      <li>
                        access or otherwise interact with our website using any
                        robot, spider or other automated means, except for the
                        purpose of search engine indexing;
                      </li>
                      <li>
                        violate the directives set out in the robots.txt file
                        for our website; or
                      </li>
                      <li>
                        use data collected from our website for any direct
                        marketing activity (including without limitation email
                        marketing, SMS marketing, telemarketing and direct
                        mailing).
                      </li>
                    </ol>
                  </li>
                  <li className="unit numberedunit">
                    You must not use data collected from our website to contact
                    individuals, companies or other persons or entities.
                  </li>
                  <li className="unit numberedunit">
                    You must ensure that all the information you supply to us
                    through our website, or in relation to our website, is true,
                    accurate, current, complete and non-misleading.
                  </li>
                </ol>
              </li>
              <li className="section numberedsection">
                <ol className="units">
                  <li className="sectionTitle">
                    <h3>Use on behalf of organisation</h3>
                  </li>
                  <li className="unit numberedunit">
                    If you use our website or expressly agree to these terms and
                    conditions in the course of a business or other
                    organisational project, then by so doing you bind both:
                    <ol className="listitem  ">
                      <li>yourself; and</li>
                      <li>
                        the person, company or other legal entity that operates
                        that business or organisational project,
                      </li>
                    </ol>
                    to these terms and conditions, and in these circumstances
                    references to "you" in these terms and conditions are to
                    both the individual user and the relevant person, company or
                    legal entity, unless the context requires otherwise.
                  </li>
                </ol>
              </li>
              <li className="section numberedsection">
                <ol className="units">
                  <li className="sectionTitle">
                    <h3>Registration and accounts</h3>
                  </li>
                  <li className="unit numberedunit">
                    You may register for an account with our website by
                    completing the account registration process on our website
                    using your web browser.
                  </li>
                  <li className="unit numberedunit">
                    You must notify us in writing immediately if you become
                    aware of any unauthorised use of your account.
                  </li>
                  <li className="unit numberedunit">
                    You must not use any other person's account to access the
                    website, unless you have that person's express permission to
                    do so.
                  </li>
                </ol>
              </li>
              <li className="section numberedsection">
                <ol className="units">
                  <li className="sectionTitle">
                    <h3>Cancellation and suspension of account</h3>
                  </li>
                  <li className="unit numberedunit">
                    We may:
                    <ol className="listitem  ">
                      <li>edit your account details;</li>
                      <li>temporarily suspend your account; and/or</li>
                      <li>cancel your account,</li>
                    </ol>
                    at any time in our sole discretion, providing that if we
                    cancel any services you have paid for and you have not
                    breached these terms and conditions, you will be entitled to
                    a refund of any amounts paid to us in respect of those
                    services that were to be provided by us to you after the
                    date of such cancellation; we will give you reasonable
                    written notice of any cancellation under this Section 7.1.
                  </li>
                  <li className="unit numberedunit">
                    You may cancel your account on our website by emailing us
                    with a request to cancel your account; we reply with a
                    request for confirmation to ensure that the email originated
                    from your account. You will not be entitled to any refund if
                    you cancel your account in accordance with this Section 7.2.
                  </li>
                </ol>
              </li>
              <li className="section numberedsection">
                <ol className="units">
                  <li className="sectionTitle">
                    <h3>Subscriptions</h3>
                  </li>
                  <li className="unit numberedunit">
                    To become a subscriber to our website services, you must pay
                    the applicable subscription fees after you have registered
                    for an account with our website. We will send you an
                    acknowledgement of your order. The contract between us for
                    the supply of the website services shall come into force
                    upon the issue of the order acknowledgement.
                  </li>
                  <li className="unit numberedunit">
                    For so long as your account and subscription remain active
                    in accordance with these terms and conditions, you will
                    benefit from the features specified on our website in
                    relation to your subscription type.
                  </li>
                  <li className="unit numberedunit">
                    We may from time to time vary the benefits associated with a
                    subscription by giving you written notice of the variation,
                    providing that, if in our reasonable opinion such a
                    variation results in a substantial loss of value or
                    functionality, you shall have the right to cancel your
                    subscription, and we will refund to you any amounts paid to
                    us in respect of any period of subscription after the date
                    of such cancellation.
                  </li>
                  <li className="unit numberedunit">
                    At the end of any period of subscription for which you have
                    paid, and subject to the other provisions of these terms and
                    conditions, your subscription will be automatically renewed
                    and you must pay to us the applicable subscription fees,
                    unless you cancel the subscription using the cancellation
                    facility on our website before the date of renewal.
                  </li>
                </ol>
              </li>
              <li className="section numberedsection">
                <ol className="units">
                  <li className="sectionTitle">
                    <h3>Fees</h3>
                  </li>
                  <li className="unit numberedunit">
                    The fees in respect of our website services will be as set
                    out on the website from time to time.
                  </li>
                  <li className="unit numberedunit">
                    All amounts stated in these terms and conditions or on our
                    website are stated exclusive of VAT, unless otherwise noted.
                  </li>
                  <li className="unit numberedunit">
                    You must pay to us the fees in respect of our website
                    services in advance, in cleared funds, in accordance with
                    any instructions on our website.
                  </li>
                  <li className="unit numberedunit">
                    We may vary fees from time to time by posting new fees on
                    our website, but this will not affect fees for services that
                    have been previously paid.
                  </li>
                  <li className="unit numberedunit">
                    If you dispute any payment made to us, you must contact us
                    immediately and provide full details of your claim.
                  </li>
                  <li className="unit numberedunit">
                    If you make an unjustified credit card, debit card or other
                    charge-back then you will be liable to pay us, within 7 days
                    following the date of our written request:{" "}
                    <ol className="listitem  ">
                      <li>an amount equal to the amount of the charge-back;</li>
                      <li>
                        all third party expenses incurred by us in relation to
                        the charge-back (including charges made by our or your
                        bank or payment processor or card issuer);
                      </li>
                      <li>
                        an administration fee of GBP 25.00 including VAT; and
                      </li>
                      <li>
                        all our reasonable costs, losses and expenses incurred
                        in recovering the amounts referred to in this Section
                        9.6 (including without limitation legal fees and debt
                        collection fees),
                      </li>
                    </ol>
                    and for the avoidance of doubt, if you fail to recognise or
                    fail to remember the source of an entry on your card
                    statement or other financial statement, and make a
                    charge-back as a result, this will constitute an unjustified
                    charge-back for the purposes of this Section 9.6.
                  </li>
                  <li className="unit numberedunit">
                    If you owe us any amount under or relating to these terms
                    and conditions, we may suspend or withdraw the provision of
                    services to you.
                  </li>
                  <li className="unit numberedunit">
                    We may at any time set off any amount that you owe to us
                    against any amount that we owe to you, by sending you
                    written notice of the set-off.
                  </li>
                </ol>
              </li>
              <li className="section numberedsection">
                <ol className="units">
                  <li className="sectionTitle">
                    <h3>Distance contracts: cancellation right</h3>
                  </li>
                  <li className="unit numberedunit">
                    This Section 10 applies if and only if you offer to contract
                    with us, or contract with us, as a consumer - that is, as an
                    individual acting wholly or mainly outside your trade,
                    business, craft or profession.
                  </li>
                  <li className="unit numberedunit">
                    You may withdraw an offer to enter into a contract with us
                    through our website, or cancel a contract entered into with
                    us through our website, at any time within the period:
                    <ol className="listitem  ">
                      <li>beginning upon the submission of your offer; and</li>
                      <li>
                        ending at the end of 14 days after the day on which the
                        contract is entered into,
                      </li>
                    </ol>
                    subject to Section 10.3. You do not have to give any reason
                    for your withdrawal or cancellation.
                  </li>
                  <li className="unit numberedunit">
                    You agree that we may begin the provision of services before
                    the expiry of the period referred to in Section 10.2, and
                    you acknowledge that, if we do begin the provision of
                    services before the end of that period, then:
                    <ol className="listitem  ">
                      <li>
                        if the services are fully performed, you will lose the
                        right to cancel referred to in Section 10.2;{" "}
                      </li>
                      <li>
                        if the services are partially performed at the time of
                        cancellation, you must pay to us an amount proportional
                        to the services supplied or we may deduct such amount
                        from any refund due to you in accordance with this
                        Section 10.
                      </li>
                    </ol>
                  </li>
                  <li className="unit numberedunit">
                    In order to withdraw an offer to contract or cancel a
                    contract on the basis described in this Section 10, you must
                    inform us of your decision to withdraw or cancel (as the
                    case may be). You may inform us by means of any clear
                    statement setting out the decision. In the case of
                    cancellation, you may inform us using the cancellation form
                    that we will make available to you. To meet the cancellation
                    deadline, it is sufficient for you to send your
                    communication concerning the exercise of the right to cancel
                    before the cancellation period has expired.
                  </li>
                  <li className="unit numberedunit">
                    If you withdraw an offer to contract, or cancel a contract,
                    on the basis described in this Section 10, you will receive
                    a full refund of any amount you paid to us in respect of the
                    offer or contract, except as specified in this Section 10.
                  </li>
                  <li className="unit numberedunit">
                    We will refund money using the same method used to make the
                    payment, unless you have expressly agreed otherwise. In any
                    case, you will not incur any fees as a result of the refund.
                  </li>
                  <li className="unit numberedunit">
                    We will process the refund due to you as a result of a
                    cancellation on the basis described in this Section 10
                    without undue delay and, in any case, within the period of
                    14 days after the day on which we are informed of the
                    cancellation.
                  </li>
                </ol>
              </li>
              <li className="section numberedsection">
                <ol className="units">
                  <li className="sectionTitle">
                    <h3>Report abuse</h3>
                  </li>
                  <li className="unit numberedunit">
                    If you learn of any unlawful material or activity on our
                    website, or any material or activity that breaches these
                    terms and conditions, please let us know.
                  </li>
                  <li className="unit numberedunit">
                    You can let us know about any such material or activity by
                    email.
                  </li>
                </ol>
              </li>
              <li className="section numberedsection">
                <ol className="units">
                  <li className="sectionTitle">
                    <h3>Limited warranties</h3>
                  </li>
                  <li className="unit numberedunit">
                    We do not warrant or represent:
                    <ol className="listitem  ">
                      <li>
                        the completeness or accuracy of the information
                        published on our website;
                      </li>
                      <li>
                        that the material on the website is up to date; or
                      </li>
                      <li>
                        that the website or any service on the website will
                        remain available.
                      </li>
                    </ol>
                  </li>
                  <li className="unit numberedunit">
                    We reserve the right to discontinue or alter any or all of
                    our website services, and to stop publishing our website, at
                    any time in our sole discretion without notice or
                    explanation; and save to the extent expressly provided
                    otherwise in these terms and conditions, you will not be
                    entitled to any compensation or other payment upon the
                    discontinuance or alteration of any website services, or if
                    we stop publishing the website.
                  </li>
                  <li className="unit numberedunit">
                    To the maximum extent permitted by applicable law and
                    subject to Section 13.1, we exclude all representations and
                    warranties relating to the subject matter of these terms and
                    conditions, our website and the use of our website.
                  </li>
                </ol>
              </li>
              <li className="section numberedsection">
                <ol className="units">
                  <li className="sectionTitle">
                    <h3>Limitations and exclusions of liability</h3>
                  </li>
                  <li className="unit numberedunit">
                    Nothing in these terms and conditions will:
                    <ol className="listitem  ">
                      <li>
                        limit or exclude any liability for death or personal
                        injury resulting from negligence;
                      </li>
                      <li>
                        limit or exclude any liability for fraud or fraudulent
                        misrepresentation;
                      </li>
                      <li>
                        limit any liabilities in any way that is not permitted
                        under applicable law; or
                      </li>
                      <li>
                        exclude any liabilities that may not be excluded under
                        applicable law,
                      </li>
                    </ol>
                    and, if you are a consumer, your statutory rights will not
                    be excluded or limited by these terms and conditions, except
                    to the extent permitted by law.
                  </li>
                  <li className="unit numberedunit">
                    The limitations and exclusions of liability set out in this
                    Section 13 and elsewhere in these terms and conditions:{" "}
                    <ol className="listitem  ">
                      <li>are subject to Section 13.1; and</li>
                      <li>
                        govern all liabilities arising under these terms and
                        conditions or relating to the subject matter of these
                        terms and conditions, including liabilities arising in
                        contract, in tort (including negligence) and for breach
                        of statutory duty, except to the extent expressly
                        provided otherwise in these terms and conditions.
                      </li>
                    </ol>
                  </li>
                  <li className="unit numberedunit">
                    To the extent that our website and the information and
                    services on our website are provided free of charge, we will
                    not be liable for any loss or damage of any nature.
                  </li>
                  <li className="unit numberedunit">
                    We will not be liable to you in respect of any losses
                    arising out of any event or events beyond our reasonable
                    control.
                  </li>
                  <li className="unit numberedunit">
                    We will not be liable to you in respect of any business
                    losses, including (without limitation) loss of or damage to
                    profits, income, revenue, use, production, anticipated
                    savings, business, contracts, commercial opportunities or
                    goodwill.
                  </li>
                  <li className="unit numberedunit">
                    We will not be liable to you in respect of any loss or
                    corruption of any data, database or software.
                  </li>
                  <li className="unit numberedunit">
                    We will not be liable to you in respect of any special,
                    indirect or consequential loss or damage.
                  </li>
                  <li className="unit numberedunit">
                    You accept that we have an interest in limiting the personal
                    liability of our officers and employees and, having regard
                    to that interest, you acknowledge that we are a limited
                    liability entity; you agree that you will not bring any
                    claim personally against our officers or employees in
                    respect of any losses you suffer in connection with the
                    website or these terms and conditions (this will not, of
                    course, limit or exclude the liability of the limited
                    liability entity itself for the acts and omissions of our
                    officers and employees).
                  </li>
                  <li className="unit numberedunit">
                    Our aggregate liability to you in respect of any contract to
                    provide services to you under these terms and conditions
                    shall not exceed the greater of:
                    <ol className="listitem  ">
                      <li>£250 GBP; and</li>
                      <li>
                        the total amount paid and payable to us under the
                        contract.
                      </li>
                    </ol>
                  </li>
                </ol>
              </li>
              <li className="section numberedsection">
                <ol className="units">
                  <li className="sectionTitle">
                    <h3>Indemnity</h3>
                  </li>
                  <li className="unit numberedunit">
                    You hereby indemnify us, and undertake to keep us
                    indemnified, against any and all losses, damages, costs,
                    liabilities and expenses (including without limitation legal
                    expenses and any amounts paid by us to a third party in
                    settlement of a claim or dispute) incurred or suffered by us
                    and arising directly or indirectly out of your use of our
                    website or any breach by you of any provision of these terms
                    and conditions.
                  </li>
                </ol>
              </li>
              <li className="section numberedsection">
                <ol className="units">
                  <li className="sectionTitle">
                    <h3>Breaches of these terms and conditions</h3>
                  </li>
                  <li className="unit numberedunit">
                    Without prejudice to our other rights under these terms and
                    conditions, if you breach these terms and conditions in any
                    way, or if we reasonably suspect that you have breached
                    these terms and conditions in any way, we may:{" "}
                    <ol className="listitem  ">
                      <li>send you one or more formal warnings;</li>
                      <li>temporarily suspend your access to our website;</li>
                      <li>
                        permanently prohibit you from accessing our website;
                      </li>
                      <li>
                        block computers using your IP address from accessing our
                        website;
                      </li>
                      <li className="">
                        contact any or all of your internet service providers
                        and request that they block your access to our website;
                      </li>
                      <li>
                        commence legal action against you, whether for breach of
                        contract or otherwise; and/or
                      </li>
                      <li>suspend or delete your account on our website.</li>
                    </ol>
                  </li>
                  <li className="unit numberedunit">
                    Where we suspend or prohibit or block your access to our
                    website or a part of our website, you must not take any
                    action to circumvent such suspension or prohibition or
                    blocking (including without limitation creating and/or using
                    a different account).
                  </li>
                </ol>
              </li>
              <li className="section numberedsection">
                <ol className="units">
                  <li className="sectionTitle">
                    <h3>Third party websites</h3>
                  </li>
                  <li className="unit numberedunit">
                    Our website includes hyperlinks to other websites owned and
                    operated by third parties; such hyperlinks are not
                    recommendations.
                  </li>
                  <li className="unit numberedunit">
                    We have no control over third party websites and their
                    contents, and subject to Section 13.1 we accept no
                    responsibility for them or for any loss or damage that may
                    arise from your use of them.
                  </li>
                </ol>
              </li>
              <li className="section numberedsection">
                <ol className="units">
                  <li className="sectionTitle">
                    <h3>Trade marks</h3>
                  </li>
                  <li className="unit numberedunit">
                    Graphile, PostGraphile, Graphile-Build, the Graphile heart,
                    our logos and our other registered and unregistered trade
                    marks are trade marks belonging to us; we give no permission
                    for the use of these trade marks, and such use may
                    constitute an infringement of our rights.
                  </li>
                  <li className="unit numberedunit">
                    The third party registered and unregistered trade marks or
                    service marks on our website are the property of their
                    respective owners and, unless stated otherwise in these
                    terms and conditions, we do not endorse and are not
                    affiliated with any of the holders of any such rights and as
                    such we cannot grant any licence to exercise such rights.
                  </li>
                </ol>
              </li>
              <li className="section numberedsection">
                <ol className="units">
                  <li className="sectionTitle">
                    <h3>Variation</h3>
                  </li>
                  <li className="unit numberedunit">
                    We may revise these terms and conditions from time to time.
                  </li>
                  <li className="unit numberedunit">
                    The revised terms and conditions shall apply to the use of
                    our website from the date of publication of the revised
                    terms and conditions on the website, and you hereby waive
                    any right you may otherwise have to be notified of, or to
                    consent to, revisions of these terms and conditions.
                  </li>
                  <li className="unit numberedunit">
                    If you have purchased any of our website services and there
                    subsists a contract under these terms and conditions in
                    respect of those website services, we will ask for your
                    express agreement to any revision of that contract. We may
                    make such revisions only for the purposes of reflecting
                    changes to applicable law, the technology we use to provide
                    the services and/or our internal business processes. We will
                    give you at least 14 days' prior written notice of any
                    revision. If you do not give your express agreement to the
                    revised terms and conditions within that period, the
                    contract between us shall be automatically terminated and
                    you will be entitled to a refund of any amounts paid to us
                    in respect of website services that were to be provided by
                    us to you after the date of such termination.
                  </li>
                </ol>
              </li>
              <li className="section numberedsection">
                <ol className="units">
                  <li className="sectionTitle">
                    <h3>Assignment</h3>
                  </li>
                  <li className="unit numberedunit">
                    You hereby agree that we may assign, transfer, sub-contract
                    or otherwise deal with our rights and/or obligations under
                    these terms and conditions - providing, if you are a
                    consumer, that such action does not serve to reduce the
                    guarantees benefiting you under these terms and conditions.
                  </li>
                  <li className="unit numberedunit">
                    You may not without our prior written consent assign,
                    transfer, sub-contract or otherwise deal with any of your
                    rights and/or obligations under these terms and conditions.{" "}
                  </li>
                </ol>
              </li>
              <li className="section numberedsection">
                <ol className="units">
                  <li className="sectionTitle">
                    <h3>Severability</h3>
                  </li>
                  <li className="unit numberedunit">
                    If a provision of these terms and conditions is determined
                    by any court or other competent authority to be unlawful
                    and/or unenforceable, the other provisions will continue in
                    effect.
                  </li>
                  <li className="unit numberedunit">
                    If any unlawful and/or unenforceable provision of these
                    terms and conditions would be lawful or enforceable if part
                    of it were deleted, that part will be deemed to be deleted,
                    and the rest of the provision will continue in effect.{" "}
                  </li>
                </ol>
              </li>
              <li className="section numberedsection">
                <ol className="units">
                  <li className="sectionTitle">
                    <h3>Third party rights</h3>
                  </li>
                  <li className="unit numberedunit">
                    A contract under these terms and conditions is for our
                    benefit and your benefit, and is not intended to benefit or
                    be enforceable by any third party.
                  </li>
                  <li className="unit numberedunit">
                    The exercise of the parties' rights under a contract under
                    these terms and conditions is not subject to the consent of
                    any third party.
                  </li>
                </ol>
              </li>
              <li className="section numberedsection">
                <ol className="units">
                  <li className="sectionTitle">
                    <h3>Entire agreement</h3>
                  </li>
                  <li className="unit numberedunit">
                    Subject to Section 13.1, these terms and conditions,
                    together with our privacy and cookies policy, shall
                    constitute the entire agreement between you and us in
                    relation to your use of our website and shall supersede all
                    previous agreements between you and us in relation to your
                    use of our website.
                  </li>
                </ol>
              </li>
              <li className="section numberedsection">
                <ol className="units">
                  <li className="sectionTitle">
                    <h3>Law and jurisdiction</h3>
                  </li>
                  <li className="unit numberedunit">
                    These terms and conditions shall be governed by and
                    construed in accordance with English law.
                  </li>
                  <li className="unit numberedunit">
                    Any disputes relating to these terms and conditions shall be
                    subject to the non-exclusive jurisdiction of the courts of
                    England.
                  </li>
                </ol>
              </li>
              <li className="section numberedsection">
                <ol className="units">
                  <li className="sectionTitle">
                    <h3>Statutory and regulatory disclosures</h3>
                  </li>
                  <li className="unit numberedunit">
                    We will not file a copy of these terms and conditions
                    specifically in relation to each user or customer and, if we
                    update these terms and conditions, the version to which you
                    originally agreed will no longer be available on our
                    website. We recommend that you consider saving a copy of
                    these terms and conditions for future reference.
                  </li>
                  <li className="unit numberedunit">
                    These terms and conditions are available in the English
                    language only.
                  </li>
                  <li className="unit numberedunit">
                    Our VAT number is 289 0709 64.
                  </li>
                  <li className="unit numberedunit">
                    The website of the European Union's online dispute
                    resolution platform is available at{" "}
                    <a href="https://webgate.ec.europa.eu/odr/main">
                      https://webgate.ec.europa.eu/odr/main
                    </a>
                    . The online dispute resolution platform may be used for
                    resolving disputes.
                  </li>
                </ol>
              </li>
              <li className="section numberedsection">
                <ol className="units">
                  <li className="sectionTitle">
                    <h3>Our details</h3>
                  </li>
                  <li className="unit numberedunit">
                    This website is owned and operated by Graphile Ltd.
                  </li>
                  <li className="unit numberedunit">
                    We are registered in England and Wales under registration
                    number 11171700, and our registered office is at Tremain
                    House, 8 Maple Drive, Kings Worthy, Winchester, Hampshire,
                    SO23 7NG, United Kingdom.
                  </li>
                  <li className="unit numberedunit">
                    You can contact us:
                    <ol className="listitem  ">
                      <li>by post, using the postal address given above; or</li>
                      <li>by email, using team@graphile.com.</li>
                    </ol>
                  </li>
                </ol>
              </li>
            </ol>
          </section>
        </div>
      </div>
    </div>
  </div>
);
